var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "400" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-type-select")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.selectType("google")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("google-event")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.selectType("local")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("local-event")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }